module.exports = __webpack_public_path__ + "static/media/arbitrum.0bff7c6b.png";